export enum MessageResponse {
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    CANCELED = 'CANCELED'
}

export type MessageAnimation = 'scale' | 'left' | 'right' | 'top' | 'bottom'
export type MessageType = 'info' | 'success' | 'error' | 'warning' | 'question'

export interface MessageOptions {
    title: string
    description: string
    htmlBody?: string
    type?: MessageType
    animation?: MessageAnimation
    showYes?: boolean
    showNo?: boolean
    showCancel?: boolean
    gradient?: boolean
    blur?: boolean
    className?: string
    yesText?: string
    noText?: string
    cancelText?: string
    yesButtonClassName?: string
    noButtonClassName?: string
    cancelButtonClassName?: string
    autoClose?: boolean
    duration?: number
    onClose?: () => void
}
